module.exports = __webpack_public_path__ + "img/combate_5000ml.7688e9d5.png";